import { LocalStorage } from 'src/app/class/local-storage';
import { TranslateManagerService } from './service/translate-manager/translate-manager.service';
import { TranslateService } from '@ngx-translate/core';
import { LocationPermissionStatus } from 'src/app/enum/geolocation';
import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Platform, MenuController, NavController } from '@ionic/angular';
import { CONSTANTS } from './config/constants';
import { AuthService } from './service/auth/auth.service';
import { Router, NavigationEnd, NavigationExtras } from '@angular/router';
import { CrewUpdatedService } from './event/crew-updated/crew-updated.service';
import { Subscription } from 'rxjs';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { Push } from 'src/app/helper/push/push-helper';
import { DeviceService } from './service/device/device.service';
import { DeviceType, PlatformName } from './enum/device-type';
import { VerificationService } from './service/verification/verification.service';
import { AlertService } from './service/alert/alert.service';
import { environment } from 'src/environments/environment';
import { NotificationService } from './service/notification/notification.service';
import {
  GeolocationService,
  GEO_INTERVAL_ACTIVE_MS,
  GEO_INTERVAL_IDLE_MS,
} from './service/geolocation/geolocation.service';
import { GeolocationEvent } from './event/geolocation/geolocation.service';
import { IGeolocationEvent } from './interface/geolocation-event';
import { SitePerformanceUpdatedService } from './event/site-performance-updated/site-performance-updated.service';
import { ISitePerformance } from './interface/site';
import { AppService } from './service/app/app.service';
import { Language } from './enum/language';
import { Preferences } from '@capacitor/preferences';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { LocalNotificationsService } from './service/local-notifications/local-notifications.service';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { InactivityReminder } from './enum/inactivity-reminder';
import { ShiftService } from './service/shift/shift.service';
import { CompanyService } from './service/company/company.service';
import { WeatherService } from './service/weather/weather.service';
import { ChatService } from './service/chat/chat.service';
import { MenuService } from './event/menu/menu.service';
import { UserUnreadMessagesUpdatedService } from './event/user-unread-messages-updated/user-unread-messages-updated.service';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Badge } from '@capawesome/capacitor-badge';
import { GeofenceNotificationsService } from './service/geofence-notifications/geofence-notifications.service';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { WHITELABEL } from './config/whitelabel';
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { AnalyticsService } from './service/analytics/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private crewUpdatedSubscription: Subscription = new Subscription();
  private signedInSubscription: Subscription = new Subscription();
  private menuRefreshSubscription: Subscription = new Subscription();

  private sitePerformanceInProgresses: Array<number> = [];
  private appBundle: string = '';
  private appName: string = 'YETI';
  private uuid: string = '';
  private appBuild: string = '';
  private appVersion: string = '';
  public disconnected: boolean = false;
  public requesting: boolean = false;
  public production: boolean;
  public requestingCompanies: boolean = false;
  public requestingUnreadMgs: boolean = false;

  private pendingCurrentCoId: number;
  private currentCoPromise: any;
  private appResumePromise: any;
  private changeListenerSubscription: Subscription;

  private registerPushNotifyPromise: any;
  private updateMenuRequesting: boolean = false;

  constructor(
    private platform: Platform,
    private menuController: MenuController,
    private localNotificationsService: LocalNotificationsService,
    private authService: AuthService,
    private router: Router,
    private crewUpdatedService: CrewUpdatedService,
    private navController: NavController,
    private deviceService: DeviceService,
    private zone: NgZone,
    private verificationService: VerificationService,
    private alertService: AlertService,
    private notificationService: NotificationService,
    private geolocationService: GeolocationService,
    private geolocationEvent: GeolocationEvent,
    private sitePerformanceUpdatedService: SitePerformanceUpdatedService,
    private translateService: TranslateService,
    private translateManager: TranslateManagerService,
    private appService: AppService,
    private network: Network,
    private shiftService: ShiftService,
    private companyService: CompanyService,
    private weatherService: WeatherService,
    private chatService: ChatService,
    private menuService: MenuService,
    private userUnreadMessagesUpdatedService: UserUnreadMessagesUpdatedService,
    private geofenceNotificationsService: GeofenceNotificationsService,
    private analyticsService: AnalyticsService
  ) {
    this.production = environment.production;
    this.sqlToLocal();
    Device.getId().then((value: any) => {
      // Removed: this.uuid = value.uuid
      this.uuid = value.identifier;
    });
    App.getInfo().then((value) => {
      this.appBundle = value.id;
      this.appName = value?.name && value?.name != '' ? value?.name : 'YETI';
      this.appBuild = value.build;
      this.appVersion = value.version;
      LocalStorage.set(CONSTANTS.localStorage.keys.appName, this.appName);
      this.locationSettings();
    });
    this.initializeApp();
    defineCustomElements(window);
  }

  private async initializeApp() {
    SocialLogin.initialize({
      google: {
        webClientId: WHITELABEL.googleWebClientId,
        iOSClientId: WHITELABEL.googleIosClientId,
      }
    }).then(()=>{
      console.log(`SocialLogin initialized with Google credentials, ${WHITELABEL.googleWebClientId}`);
    });
    if(!this.platform.is('ios') && !this.platform.is('android')) {
      await FirebaseAnalytics.initializeFirebase({
       apiKey: "AIzaSyBr-KMcLySFMN2DpOyc3zpWa6QzMG36FPo",
       authDomain: "yeti-software---fresh-start-20.firebaseapp.com",
       projectId: "yeti-software---fresh-start-20",
       storageBucket: "yeti-software---fresh-start-20.firebasestorage.app",
       messagingSenderId: "793824503515",
       appId: "1:793824503515:web:633bd377675ead0aa1cefe",
       measurementId: "G-RZQRH9Z727"
      });
    }

    await FirebaseAnalytics.setCollectionEnabled({
      enabled: true,
    });
    this.subscribeNetwork();
    this.subscribeSignInAndOut();
    this.appUrlOpen();
    this.subscribePlatform();
    this.setUpLanguage();
    this.subscribeMenuEvent();
  }

  public ngOnInit() {
    this.subscribeGeolocationEvent();
    this.subscribeSitePerfService();
    this.analyticsService.startNavigationTracking();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.menuController.close('mainMenu');
      }
    });
    this.setCompanyChannels();
    this.updateShiftLocation();
    this.subscribeCrewUpdateEvent();
    if (!this.authService?.user) {
      return;
    }
    this.analyticsService.identify(String(this.authService.user.id));
    this.updateMenuCalls();
  }

  private subscribeMenuEvent(): void {
    this.menuRefreshSubscription = this.menuService
      .callEndpointsListener()
      .subscribe(() => this.updateMenuCalls());
  }

  private updateMenuCalls(): void {
    if (!this.authService?.user?.id) {
      return;
    }
    // Approach to avoid multiple calls to endpoints.
    if (this.updateMenuRequesting) {
      return;
    }
    this.updateMenuRequesting = true;
    setTimeout(() => (this.updateMenuRequesting = false), 3000);
    // Call endpoints.
    this.getCompanies();
    this.getWeatherInfo();
    this.getUnreadMessages();
  }

  private subscribePlatform() {
    this.platform.ready().then(() => this.ready());
    this.platform.pause.subscribe(() => this.pause());
    this.platform.resume.subscribe(() => this.resume());
  }

  private subscribeNetwork() {
    this.network.onDisconnect().subscribe(() => (this.disconnected = true));
    this.network.onConnect().subscribe(() => (this.disconnected = false));
  }

  /**
   * Backup for Localstorage. If there is a cleanup in LocalStorage, what is stored in Sql goes back to LocalStorage.
   */
  private sqlToLocal() {
    if (!LocalStorage.exists(CONSTANTS.localStorage.keys.authToken)) {
      Preferences.get({ key: CONSTANTS.localStorage.keys.authToken }).then(
        (response) => {
          if (!response.value) {
            return;
          }
          LocalStorage.set(
            CONSTANTS.localStorage.keys.authToken,
            response.value
          );
        }
      );
    }
  }

  private setUpLanguage() {
    this.translateManager.listener().subscribe((language) => {
      this.translateService.setDefaultLang(language);
      LocalStorage.set(CONSTANTS.localStorage.keys.language, language);
    });
    setTimeout(async () => {
      const defaultLanguageDevice = await this.translateManager.getOSLanguage();
      const storagedLanguage = LocalStorage.get(
        CONSTANTS.localStorage.keys.language
      );
      const language =
        storagedLanguage || defaultLanguageDevice || Language.ENGLISH;
      if (!language) {
        return;
      }
      LocalStorage.set(CONSTANTS.localStorage.keys.language, language);
      this.translateManager.setLanguage(language);
    }, 500);
  }

  private appUrlOpen() {
    App.addListener('appUrlOpen', (data: any) => {
      this.zone.run(() => {
        if (data?.url?.indexOf('verify') >= 0) {
          const tokenCode = data.url.substring(data.url.lastIndexOf('/') + 1);
          if (tokenCode.length < 10) {
            this.verify({ code: tokenCode });
          } else {
            this.verify({ token: tokenCode });
          }
        } else if (data?.url?.indexOf('password') >= 0) {
          const token = data.url.substring(data.url.lastIndexOf('/') + 1);
          let navigationExtras: NavigationExtras = {
            queryParams: { token },
          };
          this.navController.navigateForward(['password'], navigationExtras);
        } else if (data?.url?.indexOf('reset') >= 0) {
          let navigationExtras: NavigationExtras;
          const tokenCode = data.url.substring(data.url.lastIndexOf('/') + 1);
          if (tokenCode.length < 10) {
            navigationExtras = {
              queryParams: { code: tokenCode },
            };
          } else {
            navigationExtras = {
              queryParams: { token: tokenCode },
            };
          }
          this.navController.navigateForward(['reset'], navigationExtras);
        } else {
          // Queries
          const splitURL: Array<any> = data?.url?.split('?');
          if (splitURL && splitURL.length > 1) {
            const params = splitURL[1].split('&');
            for (const key in params) {
              if (Object.prototype.hasOwnProperty.call(params, key)) {
                const attr = params[key].split('=');
                if (attr[0] === 'notification') {
                  this.notification(attr[1]);
                }
              }
            }
          }
        }
      });
    });
  }

  private verify(value: any) {
    if (this.authService.user || !value) {
      return;
    }
    this.requesting = true;
    this.verificationService.verify(value).subscribe({
      next: (response) => {
        this.alertService.toast(response.message);
        this.requesting = false;
        this.preAutoLogin(response);
      },
      error: (error) => {
        this.requesting = false;
        this.alertService.error(error);
      },
    });
  }

  private notification(value: string) {
    if (!this.authService.user || !value) {
      return;
    }
    this.requesting = true;
    this.notificationService
      .answer(value, true)
      .subscribe({
        next: (response) => this.alertService.toast(response.message),
        error: (error) => this.alertService.error(error),
      })
      .add(() => (this.requesting = false));
  }

  private async preAutoLogin(response: any) {
    const { value } = await Preferences.get({
      key: CONSTANTS.localStorage.keys.password,
    });
    if (response.user && /* password */ value) {
      if (response.user.email) {
        this.autoLogin(response.user.email, /* password */ value);
      } else {
        this.autoLogin(
          response.user.phone_code + response.user.phone,
          /* password */ value
        );
      }
    }
  }

  private autoLogin(emailPhone: string, password: string) {
    this.requesting = true;
    this.authService
      .login({
        email_phone: emailPhone,
        password,
      })
      .subscribe({
        error: (error) => this.alertService.error(error),
      })
      .add(() => (this.requesting = false));
  }

  private subscribeSignInAndOut() {
    this.authService.signedIn().subscribe(() => this.signedIn());
    this.authService.signedOut().subscribe(() => this.signedOut());
  }

  /**
   * !!!! LOGGED IN !!!!
   */
  private signedIn() {
    this.navController.navigateRoot(['auth', 'home']);
    this.notificationsSettings();
    if (this.authService.user?.id) {
      this.analyticsService.identify(String(this.authService.user.id));
    }
    // Create Channels
    this.setUserChannels();
    this.setCompanyChannels();
    this.locationSettings();
  }

  private setUserChannels() {
    this.userUnreadMessagesUpdatedService.createChannel(
      this.authService?.user?.id
    );
  }

  private setCompanyChannels() {
    this.crewUpdatedService.createChannel(this.authService.company?.id);
  }

  private signedOut() {
    this.analyticsService.trackLogout();
    this.deviceService
      .delete({
        token: LocalStorage.get(CONSTANTS.localStorage.keys.pushNotification),
        uuid: this.uuid,
      })
      .subscribe();
    LocalStorage.clear();
    Preferences.clear();
    this.translateManager
      .getOSLanguage()
      .then((language) => this.translateManager.setLanguage(language));
    this.pendingCurrentCoId = null;
    this.navController.navigateBack('/');
    this.geolocationService.stopTracking();
    LocalNotifications.removeAllDeliveredNotifications();
    Push.removeAllDeliveredNotifications();
    Badge.clear();
  }

  private ready() {
    if (this.platform.is('ios')) {
      // Force initial render for iOS
      this.zone.run(() => {
        setTimeout(() => {
          document.body.classList.remove('ion-page-invisible');
          SplashScreen.hide();
        }, 200);
      });
    } else {
      SplashScreen.hide();
    }
    this.localNotificationsService.cancelNotifications();
    this.updateLocationDisclosure();
  }

  private pause() {
    this.inactivityReminder();
    this.geofenceNotificationsService?.setIsBackground(true);
  }

  private resume() {
    // TODO - every photo taken is calling the resume event.
    this.localNotificationsService.cancelNotifications().then(() => {
      this.shiftService.myCrew().subscribe((response) => {
        this.crewUpdatedService.local(response.crew);
      });
    });
    clearTimeout(this.appResumePromise);
    this.appResumePromise = setTimeout(() => this.appService.resume(), 500);
    this.updateMenuCalls();
    this.geofenceNotificationsService?.setIsBackground(false);
    this.updateLocationDisclosure();
  }

  private inactivityReminder() {
    const shift = this.authService.user?.shift;
    if (
      !shift ||
      shift.ended_at ||
      ![
        InactivityReminder.ONE,
        InactivityReminder.THREE,
        InactivityReminder.SIX,
        InactivityReminder.HALF,
      ].some(
        (item) =>
          item ===
          LocalStorage.get(
            CONSTANTS.localStorage.keys.inactivityReminder,
            InactivityReminder.ONE
          )
      )
    ) {
      return;
    }
    let count = null;
    switch (LocalStorage.get(CONSTANTS.localStorage.keys.inactivityReminder)) {
      case InactivityReminder.THREE:
        count = 3;
        break;
      case InactivityReminder.SIX:
        count = 6;
        break;
      case InactivityReminder.HALF:
        count = 0.5;
        break;
      default:
        count = 1;
        break;
    }
    this.localNotificationsService.notification(
      this.translateService.instant('You are still on Shift.'),
      this.translateService.instant('Shift Reminder'),
      count
    );
  }

  public ngOnDestroy() {
    this.crewUpdatedSubscription?.unsubscribe();
    this.signedInSubscription?.unsubscribe();
    this.menuRefreshSubscription?.unsubscribe();
  }

  private subscribeGeolocationEvent() {
    this.geolocationEvent
      .listener()
      .subscribe((response) => this.geolocationEventListener(response));
  }

  private subscribeSitePerfService() {
    this.sitePerformanceUpdatedService
      .listener()
      .subscribe((data) => this.sitePerformanceUpdated(data.site_performances));
  }

  private subscribeCrewUpdateEvent() {
    this.crewUpdatedSubscription?.unsubscribe();
    this.crewUpdatedSubscription = this.crewUpdatedService
      .listener()
      .subscribe(() => this.updateShiftLocation());
  }

  private locationSettings() {
    this.locationDisclosure().then((value) => {
      if (value) {
        this.geolocationService.getCurrentGeolocation();
        this.storeLocationStatus(LocationPermissionStatus.Allowed);
      } else {
        this.storeLocationStatus(LocationPermissionStatus.AppDenied);
      }
    });
  }

  private notificationsSettings() {
    Push.requestPermissions().then((data) => {
      if (!data?.receive) {
        return;
      }
      clearInterval(this.registerPushNotifyPromise);
      this.registerPushNotifyPromise = setTimeout(
        () => this.registerPushNotification(),
        1000
      );
    });
    this.localNotificationsService.permission();
  }

  private registerPushNotification() {
    Push.addListener('registration', (response) => {
      if (!response?.value) {
        return;
      }

      if (
        LocalStorage.get(CONSTANTS.localStorage.keys.pushNotification) ==
        response.value
      ) {
        return;
      }
      let type: DeviceType | undefined;
      let platformName: PlatformName | undefined;
      if (this.platform.is('android')) {
        platformName = PlatformName.Android;
        type = DeviceType.FCM;
      } else if (this.platform.is('ios')) {
        platformName = PlatformName.iOS;
        type = DeviceType.APNS;
      }
      if (!type) {
        return;
      }
      const data = {
        token: response.value,
        uuid: this.uuid,
        app_id: this.appBundle,
        platform_name: platformName,
        type,
        app_build: this.appBuild,
        app_version: this.appVersion,
      };
      this.deviceService.store(data).subscribe({
        next: () =>
          LocalStorage.set(
            CONSTANTS.localStorage.keys.pushNotification,
            response.value
          ),
      });
    });
    Push.register();
  }

  private async locationDisclosure(): Promise<any> {
    if (
      LocalStorage.get(
        CONSTANTS.localStorage.keys.locationDisclosureAccepted
      ) === 1
    ) {
      return Promise.resolve(1);
    }

    return new Promise(async (resolve) => {
      let message = this.translateService.instant(
        'APP_NAME app collects location data when you are on a Shift even if the app is in the background. Do you want to allow this?',
        { APP_NAME: this.appName }
      );

      if (message.startsWith('APP_NAME')) {
        message = message.replace('APP_NAME', 'Yeti');
      }

      const header = this.translateService.instant('Location Access');

      if (this.appService.displayDisclosureMessage(this.platform)) {
        this.alertService
          .confirm(message, this.translateService.instant('Yes, Allow'), this.translateService.instant('No'), header)
          .then((accepted) => {
            LocalStorage.set(
              CONSTANTS.localStorage.keys.locationDisclosureAccepted,
              accepted ? 1 : 0
            );
            resolve(accepted);
          });
      } else {
        LocalStorage.set(
          CONSTANTS.localStorage.keys.locationDisclosureAccepted,
          1
        );
        resolve(this.appService.locationAllowed(this.platform));
      }
    });
  }

  private storeLocationStatus(status: LocationPermissionStatus) {
    let platformName: PlatformName | undefined;
    if (this.platform.is('ios')) {
      platformName = PlatformName.iOS;
    } else if (this.platform.is('android')) {
      platformName = PlatformName.Android;
    }
    const dataRequest = {
      uuid: this.uuid,
      app_id: this.appBundle,
      platform_name: platformName,
      location_status: status,
    };
    const json = JSON.stringify(dataRequest);
    if (
      LocalStorage.get(CONSTANTS.localStorage.keys.requestLocationStatus) !==
      json
    ) {
      LocalStorage.set(CONSTANTS.localStorage.keys.requestLocationStatus, json);
      if (dataRequest) {
        this.deviceService.store(dataRequest).subscribe();
      }
    }
  }

  private updateShiftLocation() {
    if (
      this.authService.user?.shift?.started_at &&
      !this.authService.user?.shift?.ended_at
    ) {
      this.geolocationService.startTracking();
    } else if (this.authService.user?.shift?.ended_at) {
      this.appService.clearShiftLocalStorage();
      this.geolocationService.stopTracking();
      this.localNotificationsService.cancelNotifications();
    }
  }

  private geolocationEventListener(data: IGeolocationEvent) {
    if (!this.appService.locationAllowed(this.platform)) {
      return;
    }
    this.geolocationService.getCurrentGeolocation(data);
  }

  private async sitePerformanceUpdated(
    sitePerformances?: Array<ISitePerformance>
  ) {
    sitePerformances?.forEach((sitePerformance) => {
      if (!sitePerformance.ended_at && !sitePerformance.deleted_at) {
        if (!this.sitePerformanceInProgresses) {
          this.sitePerformanceInProgresses = [];
        }
        if (
          !this.sitePerformanceInProgresses.some(
            (item) => item === sitePerformance.id
          )
        ) {
          this.sitePerformanceInProgresses.push(sitePerformance.id ?? 0);
        }
      } else {
        const index = this.sitePerformanceInProgresses?.findIndex(
          (item) => item === sitePerformance.id
        );
        if (this.sitePerformanceInProgresses?.length && index >= 0) {
          this.sitePerformanceInProgresses.splice(index, 1);
        }
      }
    });
    if (this.sitePerformanceInProgresses?.length) {
      this.geolocationService.startTracking(GEO_INTERVAL_ACTIVE_MS);
    } else {
      this.geolocationService.startTracking(GEO_INTERVAL_IDLE_MS);
    }
  }

  private getCompanies() {
    if (!this.authService?.user?.id) {
      return true;
    }
    this.requestingCompanies = true;
    this.changeListenerSubscription?.unsubscribe();
    this.changeListenerSubscription = this.companyService
      .changeListener()
      .subscribe((companyId) => this.setCurrentCompany(companyId));

    this.companyService.index().subscribe({
      next: (response) => {
        this.requestingCompanies = false;
        LocalStorage.set(
          CONSTANTS.localStorage.keys.menu.companies,
          response.companies
        );
        if (response.companies?.length) {
          let company = response.companies?.find((item) => item.selected);
          if (!company) {
            company = response.companies[0];
          }
          if (!this.authService.company) {
            this.authService.company = company;
          }
          this.menuService.updateView();
          this.setCurrentCompany(this.authService.company.id ?? 0);
        }
      },
      error: (error) => {
        this.requestingCompanies = false;
        this.alertService.error(error);
      },
    });
  }

  private currentCompanyValidation(companyId: number) {
    if (this.pendingCurrentCoId == companyId) {
      return false;
    }
    this.pendingCurrentCoId = companyId;
    clearTimeout(this.currentCoPromise);
    this.currentCoPromise = setTimeout(
      () => (this.pendingCurrentCoId = null),
      3000
    );
    return true;
  }

  private setCurrentCompany(companyId: number) {
    if (!this.currentCompanyValidation(companyId)) {
      return;
    }
    this.requestingCompanies = true;
    this.companyService
      .current(companyId)
      .subscribe({
        next: (response) => {
          this.authService.user = response.user;
          // Where user, user_company, and company are updated.
          this.setCompanyChannels();
        },
        error: (error) => this.alertService.error(error),
      })
      .add(() => {
        this.requestingCompanies = false;
        this.menuService.updateView();
      });
  }

  private getWeatherInfo() {
    if (!this.authService?.user?.id) {
      return true;
    }
    if (this.appService.locationAllowed(this.platform)) {
      const locationSubscription = this.geolocationService
        .getCurrentGeolocation()
        .subscribe((location) => {
          this.weatherService
            .show(location?.latitude, location?.longitude)
            .subscribe((weather) =>
              LocalStorage.set(
                CONSTANTS.localStorage.keys.menu.condition,
                weather?.condition
              )
            )
            .add(() => this.menuService.updateView());
          locationSubscription.unsubscribe();
        });
    }
  }

  private getUnreadMessages() {
    if (!this.authService?.user?.id) {
      return true;
    }
    this.requestingUnreadMgs = true;
    this.chatService
      .unreadMessages()
      .subscribe((response) =>
        LocalStorage.set(
          CONSTANTS.localStorage.keys.menu.unreadMessages,
          response.unread_messages
        )
      )
      .add(() => {
        this.requestingUnreadMgs = false;
        this.menuService.updateView();
      });
    return true;
  }

  private updateLocationDisclosure() {
    if (
      LocalStorage.get(
        CONSTANTS.localStorage.keys.locationDisclosureAccepted
      ) === 1
    ) {
      this.storeLocationStatus(LocationPermissionStatus.Allowed);
      return;
    }

    this.storeLocationStatus(LocationPermissionStatus.AppDenied);
  }
}
